<div class="beatmaker-catalog-page common-container">
  <h2 class="common-section-title">
    {{ lg.tracksBlock.heading }}
  </h2>
  @if (!!beatmakerId) {
    <bmcore-tracks-block
      [appType]="appType"
      [isTracksPage]="true"
      [isShowTracksAllBeatmakers]="false"
      [isBeatmakerPage]="true"
      [pageSize]="20"
      [producerId]="beatmakerId"
      [pagesWithFilter]="'bmstv-beatmaker-page'"
      [currentSortById]="BeatsSortBy.OrderNumber"
      [showVerificationIcon]="showVerificationIcon"
    >
    </bmcore-tracks-block>
  }
</div>
